import { CommonConfigDao } from "../dao";
import {
  CarBrand,
  CarModel,
  Country,
  VehicleType,
  CommonConfig
} from "../model";

export class CommonConfigService {
  private readonly _commonConfigDao: CommonConfigDao;

  public constructor(commonConfigDao: CommonConfigDao) {
    this._commonConfigDao = commonConfigDao;
  }

  public async getCarBrands(): Promise<CarBrand[]> {
    return await this._commonConfigDao.getCarBrands();
  }

  public async getCarModels(): Promise<CarModel[]> {
    return await this._commonConfigDao.getCarModels();
  }

  public async getCountries(): Promise<Country[]> {
    return await this._commonConfigDao.getCountries();
  }

  public async getVehicleTypes(): Promise<VehicleType[]> {
    return await this._commonConfigDao.getVehicleTypes();
  }

  public async getCommonConfig(): Promise<CommonConfig> {
    const commonConfig: CommonConfig = {
      carBrands: await this._commonConfigDao.getCarBrands(),
      carModels: await this._commonConfigDao.getCarModels(),
      countries: await this._commonConfigDao.getCountries(),
      vehicleTypes: await this._commonConfigDao.getVehicleTypes()
    };

    return commonConfig;
  }
}

export default CommonConfigService;
